/** Extrai preço cadastrado (promocional → varejo → primeiro) para exibição em formulários. */
export function precoProdutoCadastrado(produto, estabelecimentoId = null) {
  const precos = produto?.precos || [];
  if (!precos.length) return '';

  const estabId = estabelecimentoId != null ? Number(estabelecimentoId) : null;
  const filtrados = estabId
    ? precos.filter(
        (p) => !p.estabelecimentoId || Number(p.estabelecimentoId) === estabId,
      )
    : precos;

  const lista = filtrados.length ? filtrados : precos;
  const promo = lista.find((x) => x.tipo === 2 || x.tipo === 'Promocional');
  const varejo = lista.find((x) => x.tipo === 0 || x.tipo === 'Varejo');
  const preco = promo || varejo || lista[0];
  if (preco?.valor == null || preco.valor === '') return '';
  return String(preco.valor);
}
